import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/43/thumb-landscape.jpg"

const Post43 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">GUCCI／オフィディア／25 x17 x7cm</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>2018年クルーズ コレクションに初めて発表され、現在たくさんのシェイプが登場しているオフィディア（Ophidia）。GUCCI（グッチ）を象徴するウェブ ストライプのディテールとシャイニーゴールドのGGマーモント タブが特徴で、レトロなインスピレーションを取り入れたヴィンテージな雰囲気が人気です。今回はそんなオフィディア（Ophidia）の中でも人気のバッグの特徴とおすすめのコーディネートをご紹介します。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2>目次</h2>
        <p>
          <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80}>1.GG ショルダーバッグ</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80}>2.GG ミニ ラウンド ショルダーバッグ</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec3" smooth={true} duration={500} offset={-80}>3.GG スモール ショルダーバッグ</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80}>4.GG ミニ バケットバッグ</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80}>5.GG スモール バケットバッグ</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec6" smooth={true} duration={500} offset={-80}>6.GG ミディアム トートバッグ</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec7" smooth={true} duration={500} offset={-80}>7.まとめ</ScrollLink>             
        </p>
      </div>               
      <div name="sec1" className="text-max-width">
        <h2>1.GG ショルダーバッグ /23x19x8cm(幅x高さxマチ)</h2>      
      </div>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/43/1.jpg" alt="登場から根強い人気！GUCCI（グッチ）オフィディア（Ophidia）シリーズ"/>
        </figure>        
        <figure className="img-small">
          <StaticImage src="../../images/posts/43/2.jpg" alt="登場から根強い人気！GUCCI（グッチ）オフィディア（Ophidia）シリーズ"/>
        </figure>
      </div>
      <p className="text-max-width">
        ヴィンテージのデザインを思わせるドーム型のフォルムがポイントのデザイン。GUCCI（グッチ）の象徴でもあるダブルGが、レザーのタブ ディテールとジッパープルのトップに飾られています。カーフレザータイプもあります。インナーオープンポケット、スマートフォン用ポケットがあり、エレガントでありながら日常使いしやすいデザインです。
      </p>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/43/3.jpg" alt="登場から根強い人気！GUCCI（グッチ）オフィディア（Ophidia）シリーズ"/>
        </figure>        
        <figure className="img-small">
          <StaticImage src="../../images/posts/43/4.jpg" alt="登場から根強い人気！GUCCI（グッチ）オフィディア（Ophidia）シリーズ"/>
        </figure>
      </div>                                
      <div name="sec2" className="text-max-width">
        <h2>2.GG ミニ ラウンド ショルダーバッグ /18x18x4cm(幅x高さxマチ)</h2>
      </div>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/43/5.jpg" alt=""/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/43/6.jpg" alt=""/>
        </figure>
      </div>            
      <p className="text-max-width">             
        アンティークゴールドのチェーンショルダー付きのラウンド型バッグ。ちょっとしたお出かけにはぴったりのサイズ感です。中の仕切りはなく、ダブルG付きの ジップ クロージャーは左右に開閉可能です。
      </p>
      <Link to="https://laxus.co/app/pc/bags/gucci" className="view-all-button">
      GUCCIのバッグを見る
      </Link>             
      <div name="sec3" className="text-max-width">
        <h2>3.GG スモール ショルダーバッグ /25x17x7cm(幅x高さxマチ)</h2>
      </div>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/43/7.jpg" alt=""/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/43/8.jpg" alt=""/>
        </figure>
      </div>     
      <p className="text-max-width">
        こちらのバッグは、マグネット クロージャーで中の仕切りもあり長財布も入ります！カジュアルにもエレガントにも合わせやすいデザインです。
      </p>
      <figure className="img-small">
        <StaticImage src="../../images/posts/43/9.png" alt=""/>
      </figure>
      <p className="text-max-width">
        意外と、柄物アウターとも好相性！<br></br>GUCCI（グッチ）の象徴であるウェブ ストライプが効いており洗練された大人のカジュアルコーデに。
      </p>              
      <div name="sec4" className="text-max-width">
        <h2>4.GG ミニ バケットバッグ /15x19x9cm(幅x高さxマチ)</h2>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/43/10.jpg" alt=""/>
      </figure>
      <p className="text-max-width">
        調節可能なショルダーストラップ付き。ボトムに沿ってのウェブ ストライプがはめ込まれています。休日のポイントバッグとして◎
      </p>
      <Link to="https://laxus.co/app/pc/bags/gucci" className="view-all-button">
      GUCCIのバッグを見る
      </Link>       
      <div name="sec5" className="text-max-width">
        <h2>5.GG スモール バケットバッグ /20x26x10cm(幅x高さxマチ)</h2>
      </div>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/43/11.jpg" alt=""/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/43/12.jpg" alt=""/>
        </figure>
      </div>
      <p className="text-max-width">
        こちらはミニバゲットよりもひと回り大きいサイズ感。ウェブ ストライプもネイビー×レッドのバッグと同型のカラーがかわいい。（こちらは現在ラクサスでの取扱はカーフレザータイプのみです）
      </p>        
      <div name="sec6" className="text-max-width">
        <h2>6.GG ミディアム トートバッグ /33x26x16cm(幅x高さxマチ)</h2>
      </div>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/43/13.jpg" alt=""/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/43/14.jpg" alt=""/>
        </figure> 
      </div>     
      <p className="text-max-width">
        スクエアフォルムがヴィンテージライクなトップハンドルバッグ。インナーポケット（ジップ付き）とスマホポケット付きでA4サイズの書類も収納可能です。お仕事にも使いやすいですよね！
      </p>
      <figure className="img-small">
        <StaticImage src="../../images/posts/43/15.png" alt=""/>
      </figure>
      <p className="text-max-width">
       キレイめカジュアルコーデにポイントとして持ってもステキです♡ 
      </p>      
      <div name="sec7" className="text-two-cloumn">
        <h2>7.まとめ</h2>
        <p>
          いかがでしたでしょうか？<br></br>2015AWよりデザイナーがアレッサンドロ・ミケーレとなり、オフィディア（Ophidia）はミケーレの世界観がたっぷり詰まったバッグです。今回紹介した以外にも豊富な種類があります。<br></br>GUCCI（グッチ）は今年ブランド創設100周年、グッチのバッグでお出かけしてみてはいかがでしょうか？
        </p>
      </div>
      <Link to="https://laxus.co/app/pc/bags/gucci" className="view-all-button">
       GUCCIのバッグを見る
      </Link>  
    </section>
    <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post43

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 43}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
